export default {
  title: "Darse de baja",
  processing: "Procesando su solicitud de baja...",
  success_title: "Dado de baja con éxito",
  success_message: "Ha sido dado de baja con éxito de nuestra lista de correo.",
  error_title: "Error al darse de baja",
  error_message:
    "No pudimos procesar su solicitud de baja. Por favor intente nuevamente más tarde.",
  go_home: "Ir a la página principal",
};
